import React from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import ProjectNavigation from "../components/ProjectNavigation"
import ResponsiveImage from "../components/ResponsiveImage"

const SpyderCSU = () => {
    // Define images with their paths organized by category
    const picturesImages = [
        "/images/projects/Spyder x CSU/Pictures/In Person Presentation 1",
        "/images/projects/Spyder x CSU/Pictures/In Person Presentation 2"
    ]
    
    const flatsImages = [
        "/images/projects/Spyder x CSU/Flats/Energy Bottom Flats",
        "/images/projects/Spyder x CSU/Flats/Energy Top Flats",
        "/images/projects/Spyder x CSU/Flats/Green Bottom Flats",
        "/images/projects/Spyder x CSU/Flats/Green Top Flats",
        "/images/projects/Spyder x CSU/Flats/Tan Bottom Flats",
        "/images/projects/Spyder x CSU/Flats/Tan Top Flats",
        "/images/projects/Spyder x CSU/Flats/White Black Full Flats"
    ]
    
    const graphicsImages = [
        "/images/projects/Spyder x CSU/Graphics/Back Horns Green",
        "/images/projects/Spyder x CSU/Graphics/Back Horns Orange",
        "/images/projects/Spyder x CSU/Graphics/Back Horns Tan",
        "/images/projects/Spyder x CSU/Graphics/Front Horns Green",
        "/images/projects/Spyder x CSU/Graphics/Front Horns Orange",
        "/images/projects/Spyder x CSU/Graphics/Front Horns Tan",
        "/images/projects/Spyder x CSU/Graphics/Side Horns Green",
        "/images/projects/Spyder x CSU/Graphics/Side Horns Orange",
        "/images/projects/Spyder x CSU/Graphics/Side Horns Tan",
        "/images/projects/Spyder x CSU/Graphics/Logo" // Moved logo to the end of the array
    ]
    
    // Reorganize renders to keep front and back of the same colorway together
    const pairedRendersImages = [
        // CSU Green colorway
        [
            "/images/projects/Spyder x CSU/Renders/CSU Spyder Compression Tights CSU Green Front",
            "/images/projects/Spyder x CSU/Renders/CSU Spyder Compression Tights CSU Green Back"
        ],
        // CSU Tan colorway
        [
            "/images/projects/Spyder x CSU/Renders/CSU Spyder Compression Tights CSU Tan Front",
            "/images/projects/Spyder x CSU/Renders/CSU Spyder Compression Tights CSU Tan Back"
        ],
        // Energy Green colorway - tights
        [
            "/images/projects/Spyder x CSU/Renders/CSU Spyder Compression Tights Energy Green Front",
            "/images/projects/Spyder x CSU/Renders/CSU Spyder Compression Tights Energy Green Back"
        ],
        // CSU Green colorway - top
        [
            "/images/projects/Spyder x CSU/Renders/Compression Top CSU Green Front",
            "/images/projects/Spyder x CSU/Renders/Compression Top CSU Green Back"
        ],
        // CSU Tan colorway - top
        [
            "/images/projects/Spyder x CSU/Renders/Compression Top CSU Tan Front",
            "/images/projects/Spyder x CSU/Renders/Compression Top CSU Tan Back"
        ],
        // Energy Green colorway - top
        [
            "/images/projects/Spyder x CSU/Renders/CSU Spyder Compression Top Energy Green Front",
            "/images/projects/Spyder x CSU/Renders/Compression Top Energy Green Back"
        ]
    ]

    // Extract filename from path for captions without extension
    const getFilename = (path) => {
        const fullFilename = path.split('/').pop();
        // Remove file extension (.jpg, .JPG, .png, etc.)
        return fullFilename.replace(/\.[^/.]+$/, "");
    }

    // Function to check if image is a side horn graphic (to apply special styling)
    const isSideHorn = (path) => {
        return path.includes("Side Horns");
    }
    
    // Function to create an open in new tab button
    const OpenInNewTabButton = ({ imagePath }) => (
        <a 
            href={imagePath} 
            target="_blank" 
            rel="noopener noreferrer"
            className="open-in-new-tab-btn"
        >
            Open in new tab
        </a>
    )

    return (
        <div>
            <Header />
            <ProjectNavigation currentProject="/spydercsu" />
            
            <div style={{
                textAlign: "center",
                padding: "30px 0 20px",
                marginBottom: "10px"
            }}>
                <h1 style={{ 
                    fontSize: "32px",
                    margin: "0",
                    fontWeight: "bold"
                }}>Spyder x CSU Project</h1>
                
                <p style={{
                    maxWidth: "800px",
                    margin: "20px auto 0",
                    fontSize: "16px",
                    lineHeight: "1.6",
                    color: "#333",
                    padding: "0 20px"
                }}>
                    Garment design and graphic imagery I created for a product development class in which we worked in collaboration with Spyder to make hypothetical campus ready apparel collections.
                </p>
            </div>
            <main>
                <div style={{ 
                    padding: "20px",
                    maxWidth: "1200px", 
                    margin: "0 auto"
                }}>
                    <h2 style={{ marginBottom: "20px" }}>Renders</h2>
                    <div style={{ 
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        marginBottom: "50px"
                    }}>
                        {pairedRendersImages.map((pair, pairIndex) => (
                            <div 
                                key={`render-pair-${pairIndex}`}
                                className="spyder-renders-grid"
                            >
                                {pair.map((image, index) => (
                                    <div key={`render-${pairIndex}-${index}`}>
                                        <div style={{ 
                                            width: "100%", 
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "auto",
                                            margin: "0 auto"
                                        }}>
                                            <ResponsiveImage
                                                src={`${image}.webp`}
                                                alt={`Spyder x CSU ${image.includes("Tights") ? "compression tights" : "compression top"} in ${image.includes("Green") ? (image.includes("Energy") ? "Energy Green" : "CSU Green") : "CSU Tan"} colorway, ${image.includes("Front") ? "front view" : "back view"}`}
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "100%",
                                                    height: "auto",
                                                    objectFit: "contain"
                                                }}
                                                priority={pairIndex === 0 && index === 0}
                                                loading={pairIndex === 0 ? "eager" : "lazy"}
                                                sizes="(max-width: 767px) 100vw, 50vw"
                                            />
                                        </div>
                                        <div className="spyder-caption-container">
                                            <p className="spyder-caption-text">
                                                {getFilename(image)}
                                            </p>
                                            <OpenInNewTabButton imagePath={`${image}.webp`} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>

                    <h2 style={{ marginBottom: "20px" }}>Flats</h2>
                    <div className="spyder-flats-grid">
                        {flatsImages.map((image, index) => (
                            <div key={`flat-${index}`}>
                                <div style={{ 
                                    display: "flex",
                                    justifyContent: "center",
                                    height: "auto",
                                    margin: "0 auto",
                                    width: "100%"
                                }}>
                                    <ResponsiveImage
                                        src={`${image}.webp`}
                                        alt={`Spyder x CSU ${image.includes("Top") ? "compression top" : "compression bottoms"} technical flat drawing in ${image.includes("Energy") ? "Energy Green" : image.includes("Green") ? "CSU Green" : image.includes("Tan") ? "CSU Tan" : "White and Black"} colorway`}
                                        style={{
                                            width: "100%",
                                            maxWidth: "100%",
                                            height: "auto",
                                            objectFit: "contain"
                                        }}
                                        loading="lazy"
                                        priority={false}
                                        sizes="(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 400px"
                                    />
                                </div>
                                <div className="spyder-caption-container">
                                    <p className="spyder-caption-text">
                                        {getFilename(image)}
                                    </p>
                                    <OpenInNewTabButton imagePath={`${image}.webp`} />
                                </div>
                            </div>
                        ))}
                    </div>

                    <h2 style={{ marginBottom: "20px" }}>Graphics</h2>
                    <div className="spyder-graphics-grid">
                        {graphicsImages.map((image, index) => (
                            <div key={`graphic-${index}`}>
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    height: "auto",
                                    margin: "0 auto",
                                    padding: image.includes("Horns") ? "10px" : "0",
                                    backgroundColor: image.includes("Horns") ? "#f5f5f5" : "transparent",
                                    width: "100%"
                                }}>
                                    <ResponsiveImage
                                        src={`${image}.webp`}
                                        alt={image.includes("Logo") ? "Spyder x CSU collaboration logo graphic" : 
                                            `Spyder x CSU ${image.includes("Front") ? "front" : image.includes("Back") ? "back" : "side"} ram horns graphic in ${image.includes("Green") ? "green" : image.includes("Orange") ? "orange" : "tan"} colorway`}
                                        style={{
                                            width: "100%",
                                            maxWidth: "100%",
                                            height: "auto",
                                            maxHeight: isSideHorn(image) ? "200px" : "300px",
                                            objectFit: "contain"
                                        }}
                                        loading="lazy"
                                        priority={false}
                                        sizes="(max-width: 767px) 100vw, (max-width: 1200px) 33vw, 300px"
                                    />
                                </div>
                                <div className="spyder-caption-container">
                                    <p className="spyder-caption-text">
                                        {getFilename(image)}
                                    </p>
                                    <OpenInNewTabButton imagePath={`${image}.webp`} />
                                </div>
                            </div>
                        ))}
                    </div>

                    <h2 style={{ marginBottom: "20px" }}>Presentation Photos</h2>
                    <div style={{ 
                        display: "flex", 
                        flexDirection: "column",
                        gap: "30px", 
                        marginBottom: "50px" 
                    }}>
                        {picturesImages.map((image, index) => (
                            <div key={`picture-${index}`} style={{ width: "100%" }}>
                                <div style={{ 
                                    display: "flex",
                                    justifyContent: "center",
                                    height: "auto",
                                    margin: "0 auto",
                                    width: "100%"
                                }}>
                                    <ResponsiveImage
                                        src={`${image}.webp`}
                                        alt={`Spyder x CSU project in-person presentation photo ${index + 1}, showing the final designs displayed at ${index === 0 ? 'design review meeting' : 'client presentation'}`}
                                        style={{
                                            width: "100%",
                                            maxWidth: "100%",
                                            height: "auto",
                                            objectFit: "contain"
                                        }}
                                        loading="lazy"
                                        priority={false}
                                        sizes="(max-width: 1200px) 100vw, 1200px"
                                    />
                                </div>
                                <div className="spyder-caption-container">
                                    <p className="spyder-caption-text">
                                        {getFilename(image)}
                                    </p>
                                    <OpenInNewTabButton imagePath={`${image}.webp`} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default SpyderCSU